/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import type { WorkerRecord } from '@karya/core';

/**
 * Gets a display name for a worker.
 *
 * Extracts the worker's name from their profile in the following priority:
 * 1. worker.profile.data.full_name (primary source)
 * 2. worker.profile.name (fallback)
 * 3. "Worker {first 6 chars of ID}" (final fallback)
 *
 * @param worker - The worker record to get the display name for
 * @returns A user-friendly display name for the worker
 */
export function getWorkerDisplayName(worker: WorkerRecord): string {
  const name = worker.profile?.data?.full_name || worker.profile?.name;
  return name && name.trim() ? name : `Worker ${worker.id.slice(0, 6)}`;
}
